import { render } from "./ListTermButton.vue?vue&type=template&id=099339da&scoped=true"
import script from "./ListTermButton.vue?vue&type=script&lang=js"
export * from "./ListTermButton.vue?vue&type=script&lang=js"

import "./ListTermButton.vue?vue&type=style&index=0&id=099339da&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\xampp\\htdocs\\ui\\2025\\07\\tokyo-shoseki\\r9\\08k_sekta\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099339da"]])

export default __exports__